module.exports = __webpack_public_path__ + "static/media/icon-success.2b8c173d.svg";